import React from 'react';
import { XIcon } from 'lucide-react';
import { Section } from './Shared';
import { Daisy, FlowerSpike, Sprig } from './FloralDecor';
import { painPoints } from '../data/painPoints';
export function Workflow() {
  return <Section className="max-w-6xl" data-id="element-340" data-mp="1p61x948e8obf">
      <div className="relative overflow-hidden rounded-xl border border-stone-200 bg-amber-50/60 p-6 md:p-12" data-id="element-341" data-mp="1p50cu95hmph1">
        <Sprig className="pointer-events-none absolute -right-6 -top-6 h-56 w-32 text-emerald-600/15" data-id="element-342" data-mp="1tzml43g9w1ww" />
        <Daisy className="pointer-events-none absolute -left-4 -top-4 h-20 w-20" petalClassName="text-white" centerClassName="text-amber-300" data-id="element-343" data-mp="22yhutpiizu4y" />
        <FlowerSpike className="pointer-events-none absolute -bottom-6 left-[4%] hidden h-36 w-10 md:block" petalClassName="text-violet-300/60" centerClassName="text-emerald-300/60" data-id="element-344" data-mp="27ym9rb3scgt2" />
        <div className="relative" data-id="element-345" data-mp="dkbo1bihm2ri">
          <h2 className="text-center text-2xl font-bold tracking-tight text-emerald-900 md:text-4xl" data-id="element-346" data-mp="dleddf05vx5b">
            Che cosa succede quando manca una struttura
          </h2>

          <ul className="mt-10 grid gap-px overflow-hidden rounded-lg border border-stone-200 bg-stone-200 sm:grid-cols-2 lg:grid-cols-3" data-id="element-347" data-mp="1vq1bux62e00u">
            {painPoints.map(point => <li key={point.title} className="flex flex-col bg-white p-5" data-id="element-348" data-mp="1lywzm57rwt9p">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-rose-100 text-rose-700" aria-hidden="true" data-id="element-349" data-mp="1lx3n49ahbets">
                  <XIcon className="h-4 w-4" strokeWidth={3} data-id="element-350" data-mp="2eodm6m8ppfy0" />
                </span>
                <p className="mt-4 text-lg font-bold leading-snug text-emerald-900" data-id="element-351" data-mp="29p0pl9s1gui8">{point.title}</p>
                <p className="mt-1.5 text-sm leading-relaxed text-stone-700" data-id="element-352" data-mp="24pecd0c7ne9f">→ {point.consequence}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}